import { useState, useEffect } from "react";
import english from "../../Language/English.json";
import tamil from "../../Language/Tamil.json";

const useTranslations = () => {
   const [languageSelect, setLanguageSelect] = useState(
      sessionStorage.getItem("lng") || "English"
    );

  const translations = languageSelect === "Tamil" ? tamil : english;

  useEffect(() => {
    const interval = setInterval(() => {
      const newLanguage = sessionStorage.getItem("lng");
      if (newLanguage && newLanguage !== languageSelect) {
        setLanguageSelect(newLanguage);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [languageSelect]);

  return { languageSelect, translations, setLanguageSelect };
};

export default useTranslations;
